var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 0.375C11.3213 0.375 10.6438 0.523453 10.1293 0.820781L3.25266 4.79095C2.22417 5.38509 1.38281 6.84192 1.38281 8.02927V15.9708C1.38281 17.1585 2.22417 18.6157 3.25266 19.2096L10.1294 23.1806C10.6438 23.477 11.3217 23.625 11.9993 23.625C12.6773 23.625 13.3553 23.477 13.869 23.1806L20.7467 19.2096C21.7749 18.6157 22.6165 17.1585 22.6165 15.9708V8.02922C22.6165 6.84187 21.7749 5.385 20.7467 4.79091L13.8695 0.820828C13.3551 0.523453 12.6773 0.375 11.9992 0.375ZM9.27769 7.20642L11.9996 8.27836L14.7229 7.20642L19.4141 9.11892L16.6922 10.1903V14.8824L11.9996 16.794L7.30753 14.8824V10.1903L4.5847 9.11887L9.27769 7.20642ZM7.30753 10.1903L11.9996 12.1014L16.6922 10.1903L11.9996 8.27836L7.30753 10.1903Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialIcon);
export default __webpack_public_path__ + "static/media/material-icon.7f1c2086c6cdc44b4278e9b35cdff28a.svg";
export { ForwardRef as ReactComponent };